
import { ImageSizingModel } from '../images/image-sizing-model';
import { ProductDetailInfoModel } from './product-detail-info.model';
import { ProductNoticeModel } from './product-notice.model';

export class ProductDetailModel {
  details: ProductDetailInfoModel;
  notices: ProductNoticeModel[] = [];
  images: ImageSizingModel[] = [];

  constructor(details = undefined, notices = [], images = []) {
    this.details = details;
    this.notices = notices;
    this.images = images;
  }
}

export interface GetProductDetailWithUrlModel {
  id: number;
  slug: string;
  suggestCat: string;
  title: string;
  purpose: string;
  checkInDate: string;
  checkOutDate: string;
  guests: any;
  breakfast: boolean;
  overBudget: boolean;
  isReverseFormatDate: boolean;
  campaignId?: number;
}

export class ShaModel {
  isShaPlus: boolean;
  certificateId: string;

  constructor(isShaPlus = false, certificateId?: string) {
    this.isShaPlus = isShaPlus;
    this.certificateId = certificateId;
  }
}

export class BadgeModel {
  displaySanitation: boolean;
  displayYearOfBuild: string;
  displayYearOfRenovated: string;
  displaySecurityStandard: boolean;

  constructor(displaySanitation = false, displayYearOfBuild?: string, displayYearOfRenovated?: string, displaySecurityStandard?: boolean) {
    this.displaySanitation = displaySanitation;
    this.displayYearOfBuild = displayYearOfBuild;
    this.displayYearOfRenovated = displayYearOfRenovated;
    this.displaySecurityStandard = displaySecurityStandard;
  }
}



// WEBPACK FOOTER //
// ./src/app/model/products/product-detail.model.ts